import { ICellRendererParams } from 'ag-grid-community';
import { FC } from 'react';
import { renderProjectHours } from 'components/organisms/projects/project-list/columns/renderer/project-hours';

export const ProjectHoursCellRenderer: FC<ICellRendererParams> = ({
  value,
}) => {
  return renderProjectHours(value);
};
